export let environment: { apiUrl: string; production: boolean };
environment = {
	production: false,
	// apiUrl: 'http://localhost/ampedindia-crm/api/public'
	apiUrl: 'https://pms-api.fixura.in/public' //'http://localhost/project/nt-pms/public'
};
